import React, {useEffect, useState} from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';
import {LoadingButton} from '@mui/lab';
import DialogTransition from '../DialogTransition/DialogTansition';
import ManifestSpecPicker from '../ManifestSpecPicker/ManifestSpecPicker';
import ModeLengthPicker from '../ModeLengthPicker/ModeLengthPicker';
import ModePicker from '../ModePicker/ModePicker';
import {ISpecDef} from '../../_types/specdef';
import {IManifestSpec} from '../../_types/manifestspec';
import MonthPicker from '../MonthPicker/MonthPicker';
import YearPicker from '../YearPicker/YearPicker';

interface INewManifestSpecDialogProps {
  busy: boolean;
  equipmentSerialNumber: string;
  manifestSpec: IManifestSpec,
  specDefs: ISpecDef[];
  open: boolean;
  onClose: (equipmentSerialNumber: string, spec: IManifestSpec, cancel: boolean) => void;
}

const NewManifestSpecDialog: React.FC<INewManifestSpecDialogProps> = ({
  busy, equipmentSerialNumber, manifestSpec, specDefs, open, onClose
}): React.JSX.Element => {
  const [canCreate, setCanCreate] = useState<boolean>(false);

  useEffect(() => {
    checkCanCreate()
  }, [open]);

  const handleClose = (cancel: boolean) => {
    onClose(equipmentSerialNumber, manifestSpec, cancel);
  };

  const onSpecChange = (value: number) => {
    manifestSpec.Specification_Id = value;
    checkCanCreate();
  };

  const onEndMonthChange = (value: number) => {
    manifestSpec.MonthIndex = value;
    checkCanCreate();
  }

  const onEndYearChange = (value: number) => {
    manifestSpec.YearIndex = value;
    checkCanCreate();
  }

  const onDaysChange = (value: number) => {
    manifestSpec.NumberDays = value;
    checkCanCreate();
  }

  const onModeChange = (value: string) => {
    manifestSpec.Days0Weeks1Months2Mode = value;
    checkCanCreate();
  }

  const checkCanCreate = () => {
    const result = (
      manifestSpec.Specification_Id !== undefined
      && manifestSpec.NumberDays !== undefined
      && manifestSpec.MonthIndex !== undefined
      && manifestSpec.YearIndex !== undefined
      && manifestSpec.Days0Weeks1Months2Mode !== undefined
    );

    setCanCreate(result);
  }

  return (
    <Dialog TransitionComponent={DialogTransition} open={open}>
      <DialogTitle>New specification for {equipmentSerialNumber}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Select the values for the new specification.
        </DialogContentText>
        <div style={{margin:'15px 0 0 0'}}>
          <ManifestSpecPicker specDefs={specDefs} onChange={onSpecChange}/>
        </div>
        <div style={{margin:'15px 0 0 0'}}>
          <ModeLengthPicker initialValue={manifestSpec.NumberDays} onChange={onDaysChange}/>
        </div>
        <div style={{margin:'15px 0 0 0'}}>
          <MonthPicker initialValue={manifestSpec.MonthIndex} onChange={onEndMonthChange}/>
        </div>
        <div style={{margin:'15px 0 0 0'}}>
          <YearPicker initialValue={manifestSpec.YearIndex} onChange={onEndYearChange}/>
        </div>
        <div style={{margin:'15px 0 0 0'}}>
          <ModePicker initialValue={parseInt(manifestSpec.Days0Weeks1Months2Mode as string)} onChange={onModeChange}/>
        </div>
      </DialogContent>
      <DialogActions>
        <Button disabled={busy} onClick={() => handleClose(true)}>Cancel</Button>
        <LoadingButton disabled={!canCreate} loading={busy} color="success" onClick={() => handleClose(false)}>Create</LoadingButton>
      </DialogActions>
    </Dialog>
  )
};

export default NewManifestSpecDialog;
